// Defaults
export const DEFAULT_DAY_BACKGROUND = `url("../svg/login_background_day.svg")`;
export const DEFAULT_NIGHT_BACKGROUND = `url("../svg/login_background_night.svg")`;
export const DEFAULT_QUOTATION_BACKGROUND = `url("../city_walk.png")`;
export const DEFAULT_CALCULATOR_BACKGROUND = `url("../svg/calculator_background.svg")`;

// Festivities
export const PATRIOTIC_BACKGROUND = `url("../svg/login_background_day_patria.svg")`;
export const PATRIOTIC_QUOTATION_BACKGROUND = `url("../svg/quotation_background_day_patria.svg")`;
export const XMAS_DAY_BACKGROUND = 'url("../svg/xmas_bg_day.svg")';
export const XMAS_NIGHT_BACKGROUND = 'url("../svg/xmas_bg_night.svg")';

// Page Values
export const LOGIN_PAGE = 'login';
export const QUOTATION_PAGE = 'quotation';
export const CALCULATOR_PAGE = 'calculator';
